var map = {
	"./chat-icon-bottom-nav-mobile-active.webp": 2701,
	"./chat-icon-bottom-nav-mobile.webp": 2702,
	"./home-icon-bottom-nav-mobile-active.webp": 2703,
	"./home-icon-bottom-nav-mobile-active_b.webp": 2704,
	"./home-icon-bottom-nav-mobile.webp": 2705,
	"./home-icon-bottom-nav-mobile_b.webp": 2706,
	"./me-icon-bottom-nav-mobile-active.webp": 2707,
	"./me-icon-bottom-nav-mobile.webp": 2708,
	"./promo-icon-bottom-nav-mobile-active.webp": 2709,
	"./promo-icon-bottom-nav-mobile.webp": 2710,
	"./sponsor-icon-bottom-nav-mobile-active.webp": 2711,
	"./sponsor-icon-bottom-nav-mobile.webp": 2712,
	"./stream-icon-bottom-nav-mobile-active.webp": 2713,
	"./stream-icon-bottom-nav-mobile.webp": 2714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2700;